import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { obtenerProductos } from '../services/productoService';
import { buscarProductos, mejorResultadoBusqueda } from '../utils/productSearch';

const SearchContext = createContext(null);

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch debe ser usado dentro de un SearchProvider');
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [catalogo, setCatalogo] = useState([]);
  const [catalogoListo, setCatalogoListo] = useState(false);
  const [productoDetalle, setProductoDetalle] = useState(null);

  useEffect(() => {
    let cancelled = false;
    obtenerProductos()
      .then((lista) => {
        if (!cancelled) {
          setCatalogo(Array.isArray(lista) ? lista : []);
        }
      })
      .catch((error) => {
        console.error('[Search] No se pudieron cargar productos:', error);
      })
      .finally(() => {
        if (!cancelled) setCatalogoListo(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const abrirProducto = useCallback((producto) => {
    if (producto) {
      setProductoDetalle(producto);
    }
  }, []);

  const cerrarProducto = useCallback(() => {
    setProductoDetalle(null);
  }, []);

  const sugerenciasDe = useCallback(
    (query) => buscarProductos(catalogo, query, { limite: 6 }),
    [catalogo]
  );

  const abrirMejorResultado = useCallback(
    (query) => mejorResultadoBusqueda(catalogo, query),
    [catalogo]
  );

  const value = useMemo(
    () => ({
      catalogo,
      catalogoListo,
      productoDetalle,
      abrirProducto,
      cerrarProducto,
      sugerenciasDe,
      abrirMejorResultado,
    }),
    [catalogo, catalogoListo, productoDetalle, abrirProducto, cerrarProducto, sugerenciasDe, abrirMejorResultado]
  );

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};
